import moment from "moment-timezone";
import { getCanonicalTimezoneName } from "@rooster/utils";

export { getCanonicalTimezoneName };

export const TZ = [
  ...new Set(moment.tz.names().map((tz) => getCanonicalTimezoneName(tz)))
];
